import React, { useState, useCallback } from 'react';
import classNames from 'classnames';
import DropDown from '../dropdown';
import { Placements } from '../dropdown/enum';
import { getPrefixCls } from '../configure';
import Icon from '../icon';
import List from '../list';
import buildPlacements from './placements';
const BreadcrumbItem = ({ prefixCls: customizePrefixCls, separator = '/', menuList = [], children, overlay, listProps, dropdownProps, ...restProps }) => {
    const prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
    const [active, setActive] = useState(false);
    const isMenuListOn = menuList ? menuList.length > 0 : false;
    const onVisibleChange = useCallback(async (visible) => {
        if (isMenuListOn) {
            setActive(visible);
        }
    }, [isMenuListOn]);
    /**
     * 渲染Link
     * @param childrenLink
     * @param restPropsLink
     */
    const renderLink = (childrenLink, restPropsLink, classNameLink, key) => {
        if (key in restPropsLink) {
            return (React.createElement("a", Object.assign({ className: `${prefixCls}-${classNameLink}` }, restPropsLink), childrenLink));
        }
        return (React.createElement("span", Object.assign({ className: `${prefixCls}-${classNameLink}` }, restPropsLink), childrenLink));
    };
    /**
     * 渲染List列表
     */
    const renderList = (React.createElement(List, Object.assign({ className: `${prefixCls}-overlay-menu-list`, grid: { gutter: 0, column: 3 } }, listProps, { dataSource: menuList, renderItem: item => {
            const { href } = item;
            const { listChildren, listItemName, ...listRestProps } = item;
            let titleItem = listItemName || href;
            titleItem = listChildren ? listChildren({ href, listItemName }) : listItemName;
            return (React.createElement(List.Item, null, renderLink(titleItem, listRestProps, 'overlay-menu-list-item', 'href')));
        } })));
    const overlayMenu = overlay || (isMenuListOn && renderList);
    const onOverlayClick = useCallback(() => {
        setTimeout(() => {
            setActive(false);
        }, 300);
    }, []);
    const renderBreadcrumbMenu = (linkItem) => {
        if (overlayMenu) {
            const buildASPlacements = buildPlacements;
            const dropDownProps = {
                overlayClassName: isMenuListOn ? `${prefixCls}-overlay-popup` : undefined,
                onOverlayClick,
                overlay: overlayMenu,
                placement: isMenuListOn ? Placements.bottomLeft : Placements.bottomCenter,
                onVisibleChange,
                overlayPlacements: buildASPlacements,
                ...dropdownProps,
            };
            return (React.createElement(DropDown, Object.assign({}, dropDownProps),
                React.createElement("span", { className: classNames(`${prefixCls}-overlay-link`, {
                        [`${prefixCls}-overlay-border`]: active,
                        [`${prefixCls}-overlay-menu`]: isMenuListOn,
                    }) },
                    linkItem,
                    isMenuListOn || React.createElement(Icon, { type: "arrow_drop_down" }),
                    React.createElement("i", { className: classNames(`${prefixCls}-overlay-cover`, {
                            [`${prefixCls}-overlay-cover-active`]: active,
                        }) }))));
        }
        return linkItem;
    };
    let link = renderLink(children, restProps, `link`, 'href');
    // wrap to dropDown
    link = renderBreadcrumbMenu(link);
    if (children) {
        return (React.createElement("span", null,
            link,
            separator && separator !== '' && (React.createElement("span", { className: `${prefixCls}-separator` }, separator))));
    }
    return null;
};
BreadcrumbItem.__C7N_BREADCRUMB_ITEM = true;
export default BreadcrumbItem;
